<template>
  <search-form></search-form>
</template>

<script>

import SearchForm from "./Search/SearchForm.vue";

export default {
  name: 'Search',
  data() {
    return {
    }
  },
  components: {
    SearchForm,
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>